<template>
    <div v-if="vehicle">
        <div v-if="vehicle.nichibo_message_id" class="staff-only-messages">
            <div v-if="vehicle.message_images" class="nichibo-images">
                <h4>Bidder images</h4>
                <template v-for="photo in vehicle.message_images">
                    <a :href="photo"
                       data-fancybox="message_photo">
                        <img :src="photo" alt="Click to view a larger photo" height="25" class="message_photo"/>
                    </a>
                </template>
                <div class="clearfix"></div>
            </div>
            <template v-if="$userIsAdmin()">
                <template v-for="msg in vehicle.messages">
                    <div v-if="msg.message" class="bid history-bid" :class="vehicleMessageClass(msg)"
                         @click="selectMessage(msg)">
                        <div class="date item">
                            {{ getDate(msg.created_at) }}
                        </div>
                        <div class="hour item">
                            {{ getTime(msg.created_at) }}
                        </div>
                        <div class="message-by item">
                            {{ msg.name }}&nbsp;
                        </div>
                        <div class="note item">
                        <span>
                            <strong> staff: </strong>
                            {{ msg.message }}
                        </span>
                        </div>
                    </div>
                </template>
                <div class="history-buttons">
                    <a class="link staff-message" @click="openStaffMessageModal">
                        Nichibo Message
                    </a>
                </div>
            </template>
        </div>
        <staff-message ref="staffMessage" @changed="onStaffMessageChanged"/>
    </div>
</template>
<script>

import StaffMessage from '../VehicleSingle/StaffMessage.vue';
import {getDate, getTime} from "../../util/common";

export default {
    name: 'VehicleMessages',
    props: {
        vehicle: {
            type: Object
        },
    },
    components: {
        StaffMessage,
    },
    data() {
        return {
            selectedMessage: null,
        }
    },
    created() {
    },
    mounted() {
        const screenWidth = window.innerWidth;
        $('[data-fancybox]').fancybox({
            loop : true,
            width: screenWidth,
        });
    },
    methods: {
        getDate,
        getTime,
        onStaffMessageChanged(vehicle, vehicle_message, res){
            this.vehicle.messages.push(vehicle_message)
        },
        selectMessage(msg) {
            if (this.selectedMessage && this.selectedMessage.id === msg.id) {
                this.selectedMessage = null
            } else {
                this.selectedMessage = msg
            }
        },
        openStaffMessageModal() {
            let msg = ''
            if (this.selectedMessage)
                msg = this.selectedMessage.message.replace(/\[.*\]/, '')
            this.$refs.staffMessage.openModal(this.vehicle, msg);
        },
        vehicleMessageClass(msg) {
            let classes = ['staff-message']
            if (this.selectedMessage && this.selectedMessage.id === msg.id) {
                classes.push('selected')
            }
            return classes
        },
    }
}
</script>

<style scoped lang="scss">

@import "./resources/sass/mixins";
@import "./resources/sass/variables";
.message_photo{
    margin-left: 5px;
}
.nichibo-images{
    padding: 10px;
    h4{
        float: left;
        margin-right: 5px;
    }
    a{
        float: left;
        margin-right: 5px;
    }
}
</style>




// WEBPACK FOOTER //
// resources/js/components/Common/VehicleMessages.vue